import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { AttributeFilterService } from 'app/services/attribute-filter.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { EditService } from 'app/services/edit.service';
import { FishboneService } from 'app/services/fishbone.service';
import { FlipRoadService } from 'app/services/flip-road.service';
import { InterlayerMapService } from 'app/services/interlayer-map.service';
import { InterlayerReportService } from 'app/services/interlayer-report.service';
import { LayerService } from 'app/services/layer.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { ContentMenuItemKey, MainDataService } from 'app/services/main-data.service';
import { MapControlsService } from 'app/services/map-controls.service';
import { MapSharedService } from 'app/services/map-shared.service';
import { LRSMap } from 'assets/TS/LRSMap_New';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-feat-map-tools',
  templateUrl: './feat-map-tools.component.html',
  styleUrls: ['./feat-map-tools.component.css']
})
export class FeatMapToolsComponent implements OnInit, AfterViewInit, OnDestroy {

	@Input() mapType: 'data' | 'report' = 'data';

	map: LRSMap.Map;

	showEditBtn = true;
	isMapEditing = false;
	mapEditable = false;
	mapEditDisableReason = '';
	private mapEditDisabled: boolean;

	// showTopoModeToggle = false;
	// isNetworkTopoOn = true; // For network editing: keep topoMode or not

	showAddBtn = false;
	isAddRecordOn = false;

	showInteractiveFishbone = false;
	isInteractiveFishboneDisabled = false;
	private isInteractiveFishboneOn = false;

	showSsapLinkButton = false;
	isSsapRclModeOn: boolean;

	showLabelPainter = false;
	isLabelPainterDisabled = false;
	private isLabelPainterClean = true;
	private isLabelPainterOn = false;

	showFlipRoad: boolean;

	showSplitTool: boolean;
	showMergeTool: boolean;
	showA3iWizard: boolean;
	showAddressManage: boolean;
	showAddressRelocate: boolean;
	showLineGeomEditWizard: boolean;
	showBdryEditWizard: boolean;

	private mapReso: number;

	private contentMenuItemKey: ContentMenuItemKey;

	private mapSub: Subscription;
	private isDataSampleSub: Subscription;
	private selectedLayerSub: Subscription;
	private refLayerChangeSub: Subscription;
	private labelPainterSub: Subscription;
	private interactiveFBSub: Subscription;
	private addressesOnRoadModeSub: Subscription;
	private mapEditingSub: Subscription;
	private mapMoveendSub: Subscription;
	private mapFilterSub: Subscription;
		// private networkTopoModeSub: Subscription;
	private currentCardSub: Subscription;
	private editRecordListSub: Subscription;
	// private selectedRecordsSub: Subscription;
	private contentMenuItemKeySub: Subscription;

	constructor(
		private activityService: ActivityService,
		private attrFilterService: AttributeFilterService,
		private attrIndexService: AttrIndexService,
		private editService: EditService,
		private fishboneService: FishboneService,
		private flipRoadService: FlipRoadService,
		private layerService: LayerService,
		private mapControlsService: MapControlsService,
		private mainDataService: MainDataService,
		private mapService: MainDataMapService,
		private iMapService: InterlayerMapService,
		private mapLayerService: MainDataMapLayersService,
		private mapSharedService: MapSharedService,
		private modalService: CommonModalService,
		private reportService: InterlayerReportService
	) { }

	checkMapEditToggleEnabled() {
		let editable = true;
		this.mapEditDisableReason = '';
		// If map is already in editing mode, always enable toggle to stop editing
		if (this.isMapEditing) {
			// return true;
		}
		// If map is not in editing mode, check if editing can be enabled
		else {
			const editModeDisabled = this.editService.checkEditModeDisabled();
			const selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
			if (editModeDisabled) {
				this.mapEditDisableReason = editModeDisabled || '';
				// this.mapEditDisabled = true;
				// return false;
				editable = false;
			}
			else if (!selectedLayer) {
				this.mapEditDisableReason = 'No layer is selected.';
				// this.mapEditDisabled = true;
				// return false;
				editable = false;
			}
			else if (selectedLayer.isFishbone) {
				this.mapEditDisableReason = 'TODO: fishbone';
				// this.mapEditDisabled = true;
				// return false;
				editable = false;
			}
			else if (this.mainDataService.contentMenuItemKeyBS.getValue() === 'published') {
				this.mapEditDisableReason = 'Editting is disabled for published layers.';
				// this.mapEditDisabled = true;
				// return false;
				editable = false;
			}
			else if (this.activityService.isDataSample.getValue() !== false) {
				this.mapEditDisableReason = 'Editing is turned off while data is sampled.';
				// this.mapEditDisabled = true;
				// return false;
				editable = false;
			}
				// TODO
						// if (!this.rightClickFeature || this.isMapEditing) {
						// 	return false;
						// }
						// let isSelfAgency = null;
						// if (this.rightClickFeature) {
						// 	// Collaborative: Check if feature belongs to same agency as customer
						// 	if (this.enableDiscrepancyAgencyRule && this.selectedLayer.isFishbone !== true && this.selectedLayer.category.isCollaborative) {
						// 		const prop = this.rightClickFeature.getProperties();
						// 		isSelfAgency = this.isSelfAgency(prop[this.attrKey]);
						// 	}
						// }
						// if (isSelfAgency !== null && isSelfAgency !== true) {
						// 	this.mapEditDisableReason = 'Only features that belong to current agency can be edited';
						// 	return false;
						// }
			else if (!this.activityService.mapFilterBS.getValue().isOn) {
				this.mapEditDisableReason = 'Please turn on map filter to start editing.';
				// this.mapEditDisabled = true;
				// return false;
				editable = false;
			}
			else if (this.attrFilterService.attrFilters.getValue().filters.filter(f => f && f.filter).length) {
				this.mapEditDisableReason = 'Remove attribute filters to start map editing';
				// this.mapEditDisabled = true;
				// return false;
				editable = false;
				// const data: ConfirmModalData = {
				// 	message: 'Attribute filters will be removed to enable topology editing. Do you wish to continute?'
				// };
				// const options = this.modalService.confirmModalOptions;
				// options.data = data;
				// const res = await this.modalService.openModalWindow(ConfirmModalComponent, options);
				// if (!res) {
				// 	return;
				// } else {
				// 	// this.clearAttrFilters();
				// 	await this.getData(null, {
				// 		keepEditedData: true,
				// 		keepPrevColumns: true
				// 	});
				// }
			}
			else if (this.isLabelPainterOn) {
				this.mapEditDisableReason = 'Please turn off labeling to start map editing.'
				// this.mapEditDisabled = true;
				// return false;
				editable = false;
			}
			// this.mapEditDisabled = false;
			// return true;
		}
		if (this.mainDataService.dataEditableBS.getValue().editable !== editable) {
			this.mainDataService.dataEditableBS.next({
				editable: editable
			})
		}
		this.mapEditable = editable;
		return editable;
	}
		// toggleMapEditing() {
		// 	if (!this.checkMapEditToggleEnabled()) {
		// 		return;
		// 	}
		// 	this.isMapEditing = !this.isMapEditing;
		// 	if (this.mapType === 'data') {
		// 		this.mapService.mapEditing.next({
		// 			isOn: this.isMapEditing,
		// 			source: 'control'
		// 		});
		// 	}
		// }
	private checkShowEditBtn() {
		this.showEditBtn = this.contentMenuItemKey === 'live';
	}

	clickSingleFishbone() {
		if (this.isInteractiveFishboneDisabled) {
			return;
		}
		this.isInteractiveFishboneOn = !this.isInteractiveFishboneOn;
		if (this.isInteractiveFishboneOn) {
			this.startSingleFishbone();
		} else {
			this.stopSingleFishbone();
		}
	}
	private startSingleFishbone() {
		this.fishboneService.interactiveFishboneSubject.next('start');
	}
	private stopSingleFishbone() {
		this.fishboneService.interactiveFishboneSubject.next('stop');
	}

	clickLabelPainter() {
		if (this.isLabelPainterDisabled) {
			return;
		}
		this.isLabelPainterOn = !this.isLabelPainterOn;
		if (this.isLabelPainterOn) {
			this.startLabelPainter();
		} else {
			this.stopLabelPainter();
		}
	}

	async clickFlipRoad() {
		// const flipRoadCols: FlipRoadColumn[] = [];
		// const columns = this.mainDataService.currentColumns;
		// columns.forEach(c => {
		// 	if (c.prop.endsWith('_l') || c.prop.endsWith('_r')) {
		// 		const propWithoutDirection = c.prop.substring(0, c.prop.length - 2);
		// 		const lastSpaceIdx = c.name.lastIndexOf(' ');
		// 		const neutralName = c.name.substring(0, lastSpaceIdx);
		// 		let col: FlipRoadColumn = flipRoadCols.find(fc => fc.propWithoutDirection === propWithoutDirection);
		// 		if (!col) {
		// 			col = {
		// 				leftProp: null,
		// 				leftName: null,
		// 				rightProp: null,
		// 				rightName: null,
		// 				neutralName: neutralName,
		// 				propWithoutDirection: propWithoutDirection
		// 			};
		// 			flipRoadCols.push(col);
		// 		}
		// 		if (c.prop.endsWith('_l')) {
		// 			col.leftProp = c.prop;
		// 			col.leftName = c.name;
		// 		} else {
		// 			col.rightProp = c.prop;
		// 			col.rightName = c.name;
		// 		}
		// 	}
		// });
		// const currentCardInfo = this.activityService.currentCardBS.getValue();
		// const record = this.mainDataService.getDataAttrs(currentCardInfo.id);
		// const data: FlipRoadInput = {
		// 	cols: flipRoadCols,
		// 	record: record
		// };
		// const options: MatDialogConfig = {
		// 	data: data,
		// 	width: '450px',
		// 	height: '600px'
		// }
		// const rsp: FlipRoadOutput = await this.modalService.openModalWindow(FeatFlipRoadComponent, options);
		const rsp = await this.flipRoadService.flipRoadAttrs();
		if (!rsp || !rsp.cancel) {
			this.flipRoadService.flipRoadSubject.next({
				geom: true,
				transposeCols: rsp.cols
			});
		}
	}

	toggleAddressesOnRoadMode() {
		// const mode = this.mapService.addressesOnRoadModeBS.getValue();
		this.mapService.ssapRclLinkModeBS.next({
			isOn: this.isSsapRclModeOn //!mode.isOn
		});
	}

	// #region Data map functions
		private startLabelPainter() {
			this.mapService.labelPainerSubject.next('start');
		}
		private stopLabelPainter() {
			this.mapService.labelPainerSubject.next('stop');
		}
		add() {
			this.mapService.addNewGeomSubject.next();
		}
	// #endregion


	// toggleNetworkTopoMode() {
	// 	this.isNetworkTopoOn = !this.isNetworkTopoOn;
	// 	this.activityService.networkTopoMode.next({
	// 		isOn: this.isNetworkTopoOn
	// 	});
	// }

	private checkShowAddBtn() {
		this.showAddBtn = this.isMapEditing;
	}

	private checkShowInteractiveFishbone() {
		const map = this.map;
		const withinRange = this.mapReso <= this.mapLayerService.interactiveFishboneReso;
		if (!withinRange) {
			this.showInteractiveFishbone = false;
			return;
		}
		let hasCenterlineLayer = false;
		let hasAddressLayer = false;
		// Check selected layer
		const selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
		if (selectedLayer) {
			if (selectedLayer.category.code === this.attrIndexService.cateCodeCenterline) {
				hasCenterlineLayer = true;
			}
			if (selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
				hasAddressLayer = true;
			}
		} 
		// Check ref layer
		const refLayer = map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		const refCateCode = refLayer.getProperties()[this.attrIndexService.refLayerCodeKey];
		if (refCateCode === this.attrIndexService.cateCodeCenterline) {
			hasCenterlineLayer = true;
		}
		if (refCateCode === this.attrIndexService.cateCodeAddress) {
			hasAddressLayer = true;
		}
		if (hasCenterlineLayer && hasAddressLayer) {
			this.showInteractiveFishbone = true;
			return;
		}
		this.showInteractiveFishbone = false;
	}
	private checkInteractiveFishboneDisable() {
		this.isInteractiveFishboneDisabled = this.isMapEditing;
	}
	private checkShowSsapLink() {
		if (this.mapType === 'report') {
			this.showSsapLinkButton = false;
			return;
		}
		const selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
		if (!selectedLayer) {
			this.showSsapLinkButton = false;
			return;
		}
		if (selectedLayer.category.code !== this.attrIndexService.cateCodeAddress && selectedLayer.category.code !== this.attrIndexService.cateCodeCenterline) {
			this.showSsapLinkButton = false;
			return;
		}
		this.showSsapLinkButton = true;
	}
	private checkShowLabelPainter() {
		const map = this.map;
		let isShow = false;
		const withinLabelRange = this.mapReso <= this.mapLayerService.labelPainterReso;
		if (!withinLabelRange) {
			isShow = false;
			return isShow;
		}
		// Check selected layer
		const selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
		if (selectedLayer && selectedLayer.category.code === this.attrIndexService.cateCodeCenterline) {
			isShow = true;
			return isShow;
		} 
		// Check ref layer
		const refLayer = map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		const refCateCode = refLayer.getProperties()[this.attrIndexService.refLayerCodeKey];
		if (refCateCode === this.attrIndexService.cateCodeCenterline) {
			isShow = true;
			return isShow;
		}
		return isShow;
	}
	private checkLabelPainterDisable() {
		this.isLabelPainterDisabled = this.isMapEditing;
	}
	private checkShowFlipRoad() {
		// const editModeDisabled = this.editService.checkEditModeDisabled();
		// if (editModeDisabled) {
		// 	this.showFlipRoad = false;
		// 	return;
		// }
		// const layer = this.activityService.selectedLayerBS.getValue();
		// if (!layer.layer || layer.layer.category.code !== this.attrIndexService.cateCodeCenterline) {
		// 	this.showFlipRoad = false;
		// 	return;
		// }
		// const currentCard = this.activityService.currentCardBS.getValue();
		// if (!currentCard || !currentCard.id) {
		// 	this.showFlipRoad = false;
		// 	return;
		// }
		// if (this.mainDataService.contentMenuItemKeyBS.getValue() === 'published') {
		// 	this.showFlipRoad = false;
		// 	return;
		// }
		// if (this.activityService.isDataSample) {
		// 	this.showFlipRoad = false;
		// 	return;
		// }
		let enable = this.checkCateEditable(this.attrIndexService.cateCodeCenterline);
		const currentCard = this.activityService.currentCardBS.getValue();
		if (!currentCard || !currentCard.id) {
			enable = false;
		} 
		this.showFlipRoad = enable;
	}
		// private checkShowTopoModeToggle() {
		// 	const selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
		// 	if (this.isMapEditing && selectedLayer && selectedLayer.category.code === this.attrIndexService.cateCodeCenterline) {
		// 		this.showTopoModeToggle = true;
		// 	} else {
		// 		this.showTopoModeToggle = false;
		// 	}
		// }
	private checkCateEditable(cateCode: string, isArea?: boolean) {
		let enable = true;
		const editModeDisabled = this.editService.checkEditModeDisabled();
		const layer = this.activityService.selectedLayerBS.getValue();
		if (editModeDisabled) {
			enable = false;
		} else if (this.mainDataService.contentMenuItemKeyBS.getValue() === 'published') {
			enable = false;
		} else if (!layer.layer || (layer.layer.category.code !== cateCode && !isArea) || (isArea && layer.layer.category.geomType !== 'AREA')) {
			enable = false;
		} else if (this.activityService.isDataSample.getValue() !== false) {
			enable = false;
		}

		if (!this.activityService.mapFilterBS.getValue().isOn) {
			enable = false;
		}
		
		// const mapReso = this.map.olMap.getView().getResolution();
		// switch (cateCode) {
		// 	case this.attrIndexService.cateCodeAddress:
		// 		if (mapReso) {
					
		// 		}
		// 		break;
		// 	case this.attrIndexService.cateCodeCenterline:
		// 		break;
		// 	default:
		// 		break;
		// }
		//

		return enable;
	}
	checkShowLineSplit() {
		this.showSplitTool = this.checkCateEditable(this.attrIndexService.cateCodeCenterline);
	}
	checkShowLineMerge() {


		// TODO

		this.showMergeTool = this.checkCateEditable(this.attrIndexService.cateCodeCenterline);
	}
	private checkShowA3i() {
		this.showA3iWizard = this.checkCateEditable(this.attrIndexService.cateCodeCenterline);
	}
	private checkShowAddressManage() {
		this.showAddressManage = this.checkCateEditable(this.attrIndexService.cateCodeAddress);
	}
	private checkShowAddressRelocate() {
		this.showAddressRelocate = this.checkCateEditable(this.attrIndexService.cateCodeAddress);
	}
	private checkShowGeomEdit() {
		this.showLineGeomEditWizard = this.checkCateEditable(this.attrIndexService.cateCodeCenterline);
		this.showBdryEditWizard = this.checkCateEditable(null, true); // && !this.activityService.editRecordListBS.getValue().ids.length;
	}

	private setDataMapConfigs() {
		let isInit = true;
		this.mapSub = this.mapService.mapBS.subscribe(data => this.map = data);
		this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(l => {
			const map = this.map;
			if (!map) {
				return;
			}
			this.showLabelPainter = this.checkShowLabelPainter();
			this.checkShowInteractiveFishbone();
			// this.checkShowTopoModeToggle();
			this.checkShowSsapLink();
			this.checkShowFlipRoad();
			this.checkShowLineSplit();
			this.checkShowLineMerge();
			this.checkShowA3i();
			this.checkShowAddressManage();
			this.checkShowAddressRelocate();
			this.checkShowGeomEdit();
		});
		this.isDataSampleSub = this.activityService.isDataSample.subscribe(data => {
			this.checkShowGeomEdit();
			this.checkShowFlipRoad();
			this.checkShowLineSplit();
			this.checkShowLineMerge();
			this.checkShowA3i();
			this.checkShowAddressManage();
			this.checkShowAddressRelocate();
		});
		this.mapFilterSub = this.activityService.mapFilterBS.subscribe(data => {
			this.checkShowGeomEdit();
			this.checkShowFlipRoad();
			this.checkShowLineSplit();
			this.checkShowLineMerge();
			this.checkShowA3i();
			this.checkShowAddressManage();
			this.checkShowAddressRelocate();
		})
		this.refLayerChangeSub = this.activityService.bgRefLayerChange.subscribe(() => {
			const map = this.map;
			if (!map) {
				return;
			}
			this.showLabelPainter = this.checkShowLabelPainter();
			this.checkShowInteractiveFishbone();
		});
		this.labelPainterSub = this.mapService.labelPainerSubject.subscribe(data => {
			if (data === 'start') {
				this.isLabelPainterOn = true;
				this.isLabelPainterClean = false; // TODO
			} else if (data === 'stop') {
				this.isLabelPainterOn = false;
			} else if (data === 'clear') {
				this.isLabelPainterClean = true;
			}
		});
		this.interactiveFBSub = this.fishboneService.interactiveFishboneSubject.subscribe(data => {
			if (data === 'start') {
				this.isInteractiveFishboneOn = true;
			} else if (data === 'stop') {
				this.isInteractiveFishboneOn = false;
			}
		});
		this.addressesOnRoadModeSub = this.mapService.ssapRclLinkModeBS.subscribe(data => {
			this.isSsapRclModeOn = data.isOn;
		});
		this.mapEditingSub = this.mapService.mapEditing.subscribe(data => {
			if (!isInit && data) {
				// if (data.source !== 'control') {
				this.isMapEditing = data.isOn;
				// Label painter
				if (this.isMapEditing && this.isLabelPainterOn) {
					this.stopLabelPainter();
				}
				if (this.isMapEditing && this.isInteractiveFishboneOn) {
					this.stopSingleFishbone();
				}
				// }
				this.checkShowAddBtn();
				this.checkLabelPainterDisable();
				// Interactive fishbone
				this.checkInteractiveFishboneDisable();
					// Topo mode
					// this.checkShowTopoModeToggle();
			}
		});
		this.mapMoveendSub = this.mapService.mapMoveendSubject.subscribe(() => {
			if (isInit) {
				return;
			}
			const map = this.map;
			const reso = map.olMap.getView().getResolution();
			this.mapReso = reso;
			// this.zoomLevel = this.mapService.map.olMap.getView().getZoom().toFixed(1); // + '; reso: ' + this.mapService.map.olMap.getView().getResolution();

			let showLabel = this.checkShowLabelPainter();
			if (showLabel !== this.showLabelPainter) {
				this.showLabelPainter = showLabel;
				this.mapService.toggleLabelElemVisib(showLabel);
			}

			this.checkShowInteractiveFishbone();
			this.checkShowFlipRoad();
			this.checkShowLineSplit();
			this.checkShowLineMerge();
			this.checkShowA3i();
			this.checkShowAddressManage();
			this.checkShowAddressRelocate();
			this.checkShowGeomEdit();
		});
			// this.networkTopoModeSub = this.activityService.networkTopoMode.subscribe(data => {
			// 	this.isNetworkTopoOn = data.isOn;
			// });

		// this.selectedRecordsSub = this.activityService.selectedRecordsBS.subscribe(data => {
		// 	if (data && data.ids.length) {
		// 		this.showZoomToRecord = true;
		// 	} else {
		// 		this.showZoomToRecord = false;
		// 	}
		// 	this.checkShowFlipRoad();
		// });
		this.currentCardSub = this.activityService.currentCardBS.subscribe(data => {
			this.checkShowFlipRoad();
		});
		this.editRecordListSub = this.activityService.editRecordListBS.subscribe(data => {
			// this.checkShowGeomEdit();
		})
		isInit = false;
	}
	private setReportMapConfigs() {
		let isInit = true;

		this.mapSub = this.mapService.mapBS.subscribe(data => this.map = data);

		this.currentCardSub = this.activityService.currentCardBS.subscribe(data => {
			// if (data && data.id) {
			// 	this.showZoomToRecord = true;
			// } else {
			// 	this.showZoomToRecord = false;
			// }
		});
		this.mapMoveendSub = this.iMapService.mapMoveendSubject.subscribe(() => {
			if (isInit) {
				return;
			}
		});

		isInit = false;
	}

	// private getMap() {
	// 	const map: LRSMap.Map = this.mapType === 'data' ? this.mapService.map : this.iMapService.map;
	// 	return map;
	// }

	ngOnInit() {
		this.contentMenuItemKeySub = this.mainDataService.contentMenuItemKeyBS.subscribe(data => {
			this.contentMenuItemKey = data;
			this.checkShowEditBtn();
		});
	}
	ngAfterViewInit(): void {
		switch (this.mapType) {
			case 'data':  this.setDataMapConfigs(); break;
			case 'report': this.setReportMapConfigs(); break;
		}
	}
	ngOnDestroy(): void {
		this.currentCardSub.unsubscribe();
		this.mapSub.unsubscribe();
		// this.selectedRecordsSub.unsubscribe();
		if (this.mapType === 'data') {
			this.isDataSampleSub.unsubscribe();
			this.selectedLayerSub.unsubscribe();
			this.refLayerChangeSub.unsubscribe();
			this.labelPainterSub.unsubscribe();
			this.mapEditingSub.unsubscribe();
			this.mapMoveendSub.unsubscribe();
			this.mapFilterSub.unsubscribe();
			this.editRecordListSub.unsubscribe();
			// this.networkTopoModeSub.unsubscribe();
			this.contentMenuItemKeySub.unsubscribe();
		} else if (this.mapType === 'report') {
		}

	}
}
